//AOS SCRIPT START
AOS.init({
  duration: 1200,
  disable: 'phone, tablet, mobile',
});
AOS.refresh();
AOS.refreshHard();
//AOS SCRIPT END


$(document).ready(function () {
  setTimeout(function () {
    if ($('.action-card-animation').length) {
      $(".action-card-animation").find('.action-card-grid:nth-child(4)').nextAll().attr("data-aos", "fade-up");
      AOS.refresh();
      AOS.refreshHard();
    }
    if ($(".action-card-grid").length) {
      window.addEventListener('load', AOS.refresh);
    }
  }, 0);
});
$(function () {
  if ($(".action-card-grid").length) {
    window.addEventListener('load', AOS.refresh);
  }
});
